import { MouseEventHandler, useEffect, useRef, useState } from "react";

import { randomString } from "../Functions";

import './SVGComponent.scss';

const SVGComponent = ({ 
    src, 
    className = "", style = {},
    color, backgroundColor, stroke, width, height,
    onClick
}:{ 
    src: string, 
    className?: string, style?: React.CSSProperties, 
    color?: string, backgroundColor?: string, stroke?: string, width?: number, height?: number,
    onClick?: MouseEventHandler<HTMLDivElement>
}) => {

    const [uniqueId] = useState(()=>randomString(16));
    const svgRef = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
        const fetchSvg = async () => {

            try {
                const response = await fetch(src);
                const svgText = await response.text();
                const parser = new DOMParser()
                let parsedSvg = parser.parseFromString(svgText, 'image/svg+xml').querySelector('svg');
                
                if ( !parsedSvg || !svgRef.current ) return;

                parsedSvg.setAttribute("width", `${width}`)
                parsedSvg.setAttribute("height", `${height}`)
                
                if (backgroundColor) {
                    parsedSvg.setAttribute("style", `fill: ${backgroundColor}`);
                }
                
                if ( color || stroke ) {
                    const allPaths = parsedSvg.querySelectorAll('path');
                    if ( allPaths.length === 0 ) {
                        return;
                    }
                    
                    for ( const path of allPaths ) {
                        if ( color ) {
                            path.setAttribute("style", `fill: ${color}`);
                        }
                        if ( stroke ) {
                            path.setAttribute("style", `stroke: ${stroke}`)
                        }
                    } 
                }
                    
                svgRef.current.appendChild(parsedSvg);

            } catch (error) {
                console.error('Failed to fetch SVG:', error);
            }
        };
        
        fetchSvg();

        const currentRef = svgRef.current;

        return () => {
            if (currentRef) {
              while (currentRef.firstChild) {
                currentRef.removeChild(currentRef.firstChild);
              }
            }
        };
    }, [backgroundColor, color, height, src, stroke, width]);


    return (
        <div
            onClick={onClick}
            key={uniqueId} 
            ref={svgRef} 
            className={`SvgComponent ${className}`} 
            style={{width, height, ...style}} 
        />
    )
}

export default SVGComponent;